import { render, staticRenderFns } from "./CategoryDictionaries.vue?vue&type=template&id=bc7f8460&scoped=true&"
import script from "./CategoryDictionaries.vue?vue&type=script&lang=js&"
export * from "./CategoryDictionaries.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDictionaries.vue?vue&type=style&index=0&id=bc7f8460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7f8460",
  null
  
)

export default component.exports